import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { BehaviorSubject, Observable } from "rxjs";
import { ChamadoSuporte } from "../api/dto/chamado-suporte";
import { ChamadoSuporteAvaliacao } from "../api/dto/chamado-suporte-avaliacao";
import { ChamadoSuporteRequest } from "../api/dto/chamado-suporte-request";
import { MonitoramentoSuporte } from "../api/dto/monitoramento-suporte";
import { GraficoBarraSimplificado } from "../api/dto/grafica-barra-simplificado";
import { Paginador } from "../api/dto/paginacao/paginador";
import { MonitoramentoSuporteGraficoPizza } from "../api/dto/monitoramento-suporte-grafico-pizza";

@Injectable({
    providedIn: 'root',
})
export class ChamadoSuporteService {

    constructor(private http: HttpClient){}

    private url : string = UrlServidor.URL_BASE + 'chamados-suporte';

    buscarPorId(idChamado?: number): Observable<ChamadoSuporte> {
        return this.http.get<ChamadoSuporte>(`${this.url}/${idChamado}`);
    }

    buscarPorIdEEmpresa(idChamado?: number, idEmpresa?: number): Observable<ChamadoSuporte> {
        return this.http.get<ChamadoSuporte>(`${this.url}/${idChamado}/empresa/${idEmpresa}`);
    }

    obterMonitoramentoPorAdministradoraId(administradoraId?: number): Observable<MonitoramentoSuporte> {
        return this.http.get<MonitoramentoSuporte>(`${this.url}/administradora/${administradoraId}/monitoramento`);
    }

    obterMonitoramentoGraficoPizzaPorAdministradoraId(administradoraId?: number,
         numeroDias?: number): Observable<MonitoramentoSuporteGraficoPizza[]> {
        return this.http.get<MonitoramentoSuporteGraficoPizza[]>
        (`${this.url}/administradora/${administradoraId}/monitoramento-grafico-pizza/dias/${numeroDias}`);
    }

    obterChamadosEncerradosPorPeriodoDias(administradoraId?: number, numeroDias?: number): Observable<GraficoBarraSimplificado[]> {
        return this.http.get<GraficoBarraSimplificado[]>
        (`${this.url}/administradora/${administradoraId}/monitoramento/encerrados/dias/${numeroDias}`);
    }

    obterMediaAvaliacaoFranquia(administradoraId?: number): Observable<number> {
        return this.http.get<number>
        (`${this.url}/administradora/${administradoraId}/media-avaliacao`);
    }
 
    listarPorEmpresaId(idEmpresa?: number, numeroPagina?: number, tamanhoPagina?: number, ordenacao?: string,
         inputBusca?: string, status?: string, solicitado?: string): Observable<Paginador<ChamadoSuporte>> {

        let params = new HttpParams();
        if(tamanhoPagina) {
            params = params.set('tamanho', tamanhoPagina);
        }
        if(ordenacao) {
            params = params.set('sort', ordenacao);
        }
        if(inputBusca) {
            params = params.set('busca', inputBusca);
        }
        if(status) {
            params = params.set('status', status);
        }
        if (solicitado) {
            params = params.set('solicitado', solicitado);
        }

        return this.http.get<Paginador<ChamadoSuporte>>(`${this.url}/empresa/${idEmpresa}/pagina/${numeroPagina}`, {params});
    }

    listarPorAdministradora(id?: number, numeroPagina?: number, tamanhoPagina?: number,
         ordenacao?: string, inputBusca?: string, status?: string, solicitado?: string,
          tipoAtendimento?: string): Observable<Paginador<ChamadoSuporte>> {


        let params = new HttpParams();
        if(tamanhoPagina) {
            params = params.set('tamanho', tamanhoPagina);
        }
        if(ordenacao) {
            params = params.set('sort', ordenacao);
        }
        if(inputBusca) {
            params = params.set('busca', inputBusca);
        }
        if(status) {
            params = params.set('status', status);
        }
        if (solicitado) {
            params = params.set('solicitado', solicitado);
        }

        if (tipoAtendimento) {
            params = params.set('tipo', tipoAtendimento);
        }

        return this.http.get<Paginador<ChamadoSuporte>>(`${this.url}/administradora/${id}/pagina/${numeroPagina}`, {params});
    }

    buscarUltimoPorEmpresaId(id?: number): Observable<ChamadoSuporte> {
        return this.http.get<ChamadoSuporte>(`${this.url}/ultimo/empresa/${id}`);
    }

    salvar(chamadoSuporte?: ChamadoSuporteRequest): Observable<ChamadoSuporte> {
        return this.http.post<ChamadoSuporte>(this.url, chamadoSuporte);
    }

    encerrar(chamadoSuporte?: ChamadoSuporteRequest): Observable<void> {
        return this.http.post<void>(`${this.url}/encerrar`, chamadoSuporte);
    }

    avaliar(avaliacao?: ChamadoSuporteAvaliacao): Observable<void> {
        return this.http.post<void>(`${this.url}/avaliar`, avaliacao);
    }

    atualizarSituacaoChamado(chamadoId?: number, status?: string): Observable<void> {
        let params = new HttpParams();
        if(status) {
            params = params.set('status', status);
        }
        return this.http.put<void>(`${this.url}/${chamadoId}/situacao-atendimento`, {}, {params});
    }

}